import { jsxs, jsx } from "react/jsx-runtime";
import { memo } from "react";
import { CarTile } from "@perxis-auto/ui-kit/lib/components/CarTile";
import { Row, Col } from "@perxis-auto/ui-kit/lib/components/Grid";
import clsx from "clsx";
import "react-i18next";
import "@perxis-auto/ui-kit/lib/components/Typography";
import "../../../shared/config/env.js";
import "../../../shared/config/events.js";
import "../../../shared/lib/store/createAppApi.js";
import "../../../shared/lib/store/createAppAsyncThunk.js";
import "../../../shared/lib/store/createAppSelector.js";
import "../../../shared/lib/store/createAppSlice.js";
import "redux";
import "../../../shared/lib/store/hooks/useAppDispatch.js";
import "../../../shared/lib/store/hooks/useAppSelector.js";
import "../../../shared/lib/store/hooks/useAppStore.js";
import "../../../shared/store/config/middleware/index.js";
import "../../../shared/store/config/model/selectors/selectBenefits.js";
import "../../../shared/store/config/model/selectors/selectBooking.js";
import "../../../shared/store/config/model/selectors/selectCredit.js";
import "../../../shared/store/config/model/selectors/selectFilterGrid.js";
import "../../../shared/store/config/model/selectors/selectFilterGridItems.js";
import "../../../shared/store/config/model/selectors/selectFilters.js";
import "../../../shared/store/config/model/selectors/selectGeolocator.js";
import "../../../shared/store/config/model/selectors/selectLocationCollectionIds.js";
import "../../../shared/store/config/model/selectors/selectMaps.js";
import "../../../shared/store/config/model/selectors/selectModels.js";
import "../../../shared/store/config/model/selectors/selectSort.js";
import "../../../shared/store/config/model/selectors/selectTags.js";
import "../../../shared/store/config/model/selectors/selectTradeIn.js";
import "../../../shared/store/config/model/slice.js";
import "@perxis-auto/ui-kit/lib/components/Loader";
import "../../../shared/context/constructor.js";
import "../../../shared/context/this.js";
import "@perxis-auto/shared/lib";
import "@perxis-auto/shared";
import "../../../shared/lib/constructor/mergeConstructor.js";
import "@perxis-auto/ui-kit";
import "../../../shared/ui/constructorItem/ConstructorItem.js";
import "react-router";
import "@perxis-auto/shared/lib/lib/is/isObject";
import { PairBlockButton } from "../../../shared/ui/pairBlockButton/PairBlockButton.js";
const TileActions = memo(function TileActions2({
  isLoading,
  t,
  isCompared,
  isClickableComparison,
  toggleComparisonText,
  onComparisonClick,
  onComparisonToggle,
  onComparisonRedirect,
  isFavorite,
  isClickableFavorite,
  toggleFavoriteText,
  onFavoriteClick,
  onFavoriteToggle,
  onFavoriteRedirect,
  className,
  ...props
}) {
  if (isLoading) {
    return null;
  }
  return /* @__PURE__ */ jsxs(Row, { gutter: [8, 0], className: clsx("tileActions", className), ...props, children: [
    /* @__PURE__ */ jsx(Col, { flex: "none", children: /* @__PURE__ */ jsx(
      CarTile.ButtonTooltip,
      {
        isActive: isCompared,
        icon: "compare",
        onClick: onComparisonClick,
        hoverableTooltipContent: toggleComparisonText,
        clickableTooltipContent: () => isClickableComparison ? /* @__PURE__ */ jsx(
          PairBlockButton,
          {
            icon: [isCompared ? "minus" : "plus", "forward"],
            onClick: [onComparisonToggle, onComparisonRedirect],
            children: [toggleComparisonText, t("widgets.tileActions.comparison.redirect")]
          }
        ) : null
      }
    ) }),
    /* @__PURE__ */ jsx(Col, { flex: "none", children: /* @__PURE__ */ jsx(
      CarTile.ButtonTooltip,
      {
        isActive: isFavorite,
        icon: "favorites",
        onClick: onFavoriteClick,
        hoverableTooltipContent: toggleFavoriteText,
        clickableTooltipContent: () => isClickableFavorite ? /* @__PURE__ */ jsx(
          PairBlockButton,
          {
            icon: [isFavorite ? "minus" : "plus", "forward"],
            onClick: [onFavoriteToggle, onFavoriteRedirect],
            children: [toggleFavoriteText, t("widgets.tileActions.favorites.redirect")]
          }
        ) : null
      }
    ) })
  ] });
});
export {
  TileActions
};
